import {
  alertMessagesArgsConfig,
  collectionArgsConfig,
  collectionFieldArgsConfig,
  getItemIdFromArgsConfig,
  onlyRedirectArgsConfig,
  retainUrlParamsArgsConfig,
} from '../../utils/event_constants';

export const signzyActions = [
  {
    name: 'createConsentRequest',
    label: 'Create Consent Request',
    args: [
      collectionFieldArgsConfig({
        name: 'userMobileField',
        label: 'Select User Phone Number Field',
      }),
      ...getItemIdFromArgsConfig,
      {
        name: 'consentType',
        label: 'Select Consent Type',
        type: 'dropdown',
        optionsType: 'consentType',
        options: [
          { label: 'One Time', value: 'one_time' },
          { label: 'Periodic', value: 'periodic' },
        ],
        value: '',
      },
      {
        name: 'openInNewTab',
        label: 'Open Consent Page in New Tab',
        type: 'boolean',
        value: false,
      },
      onlyRedirectArgsConfig,
      retainUrlParamsArgsConfig,
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'fetchFinancialInformation',
    label: 'Fetch Financial Information',
    args: [
      {
        name: 'getRequestIdFrom',
        label: 'Get Request Id From',
        type: 'dropdown',
        optionsType: 'getItemIdFromApi',
        value: '',
      },
      collectionFieldArgsConfig({
        name: 'transactionStatusField',
        label: 'Select the field to store transaction fetch status',
        optionsType: 'accountHolderFieldApi',
      }),
      {
        name: 'browserStorageLocationRequest',
        label: 'Session Storage Location (Optional)',
        type: 'browserStorageLocation',
        optionsType: 'browserStorageLocationOptionsApi',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'browserStorageItemIdPathRequest',
        label: 'Browser Storage Key',
        type: 'text',
        placeholder: 'Item Id Path (ex. sessionKey.uuid)',
        value: '',
      },
      {
        name: 'accountHolderField',
        label: 'Account Holder Reference Field',
        type: 'dropdown',
        optionsType: 'accountHolderFieldApi',
        options: [],
        value: '',
        optional: true,
      },
      {
        name: 'fiTransactionsField',
        label: 'FI Transactions Reference Field',
        type: 'dropdown',
        optionsType: 'fiTransactionsFieldApi',
        options: [],
        value: '',
        optional: true,
      },
      ...getItemIdFromArgsConfig,
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'signzyDigitalDocSign',
    label: 'Digital Document Signing',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'pdfField', label: 'Select PDF Field' }),
      {
        name: 'contractExecuterName',
        label: 'Contract Executer Name',
        type: 'text',
        value: '',
      },
      {
        name: 'contractTtl',
        label: 'Contract Expiry Time (in seconds)',
        type: 'number',
        value: '',
      },
      {
        name: 'signerIdentifierField',
        label: 'Signer Identifier Field',
        type: 'dropdown',
        optionsType: 'signerIdentifierFieldApi',
        options: [],
        value: '',
      },
      {
        name: 'signerIdentifierValueFrom',
        label: 'Signer Identifier Value From',
        type: 'dropdown',
        optionsType: 'signerIdentifierValueFromApi',
        options: [
          { value: 'default', label: 'Current Item ID (Default)' },
          { value: 'loggedInUser', label: 'Signer Identifier Value from Logged In User' },
        ],
        value: 'default',
      },
      {
        name: 'contractsField',
        label: 'Contract Reference Field',
        type: 'dropdown',
        optionsType: 'contractsFieldApi',
        options: [],
        value: '',
        optional: true,
      },
      collectionFieldArgsConfig({
        name: 'pdfSaveField',
        label: 'PDF Save Field',
      }),
      ...getItemIdFromArgsConfig,
      {
        name: 'signaturePageNo',
        label: 'Signature Page No',
        type: 'text',
        value: '',
      },
      {
        name: 'addEStampPayload',
        label: 'Add E-Stamp Payload',
        type: 'boolean',
        value: false,
      },
      {
        name: 'firstPartyName',
        label: 'First Party Name',
        type: 'text',
        value: '',
      },
      collectionFieldArgsConfig({
        name: 'secondPartyNameField',
        label: 'Select Second Party Name Field',
      }),
      {
        name: 'stampDutyPaidBy',
        label: 'Stamp Duty Paid By',
        type: 'text',
        value: '',
      },
      collectionFieldArgsConfig({
        name: 'considerationPriceField',
        label: 'Select Consideration Price Field',
      }),
      collectionFieldArgsConfig({
        name: 'stateCode',
        label: 'State Code',
      }),
      collectionFieldArgsConfig({
        name: 'articleCode',
        label: 'Article Code',
      }),
      collectionFieldArgsConfig({
        name: 'stampDutyValue',
        label: 'Stamp Duty Value',
      }),
      collectionFieldArgsConfig({
        name: 'purposeOfStampDuty',
        label: 'Purpose of Stamp Duty',
      }),
      collectionFieldArgsConfig({
        name: 'mergeLimit',
        label: 'Merge Limit',
      }),
      {
        name: 'lossCap',
        label: 'Loss Cap',
        type: 'number',
        value: '',
      },
      {
        name: 'dynamicStampConsumption',
        label: 'Dynamic Stamp Consumption',
        type: 'boolean',
        value: false,
      },
      {
        name: 'location',
        label: 'Select Defacement Location',
        type: 'dropdown',
        optionsType: 'defacementLocationType',
        options: [
          { label: 'Top Left', value: 'topLeft' },
          { label: 'Top Center', value: 'topCenter' },
          { label: 'Middle Left', value: 'middleLeft' },
          { label: 'Middle Center', value: 'middleCenter' },
          { label: 'Bottom Left', value: 'bottomLeft' },
          { label: 'Bottom Center', value: 'bottomCenter' },
        ],
        value: '',
      },
      {
        name: 'redirect',
        label: 'Redirect to E-Sign Page',
        type: 'boolean',
        value: false,
      },
      {
        name: 'openInNewTab',
        label: 'Open E-Sign Page in New Tab (In case of single signer)',
        type: 'boolean',
        value: false,
      },
      {
        name: 'successRedirectUrl',
        label: 'Select Success Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'failureRedirectUrl',
        label: 'Select Error Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      retainUrlParamsArgsConfig,
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'fetchContractDetails',
    label: 'Fetch Contract Details',
    args: [
      {
        name: 'getContractIdFrom',
        label: 'Get Contract Id From',
        type: 'dropdown',
        optionsType: 'getContractIdFrom',
        options: [
          { value: 'default', label: 'Current Item ID (Default)' },
          { value: 'loggedInUser', label: 'Contract ID from Logged In User' },
        ],
        value: '',
      },
      {
        name: 'signerIdentifierField',
        label: 'Signer Identifier Field',
        type: 'dropdown',
        optionsType: 'signerIdentifierFieldApi',
        options: [],
        value: '',
      },
      {
        name: 'signerIdentifierValueFrom',
        label: 'Signer Identifier Value From',
        type: 'dropdown',
        optionsType: 'signerIdentifierValueFromApi',
        options: [
          { value: 'default', label: 'Current Item ID (Default)' },
          { value: 'loggedInUser', label: 'Signer Identifier Value from Logged In User' },
        ],
        value: 'default',
      },
      {
        name: 'contractsField',
        label: 'Contract Reference Field',
        type: 'dropdown',
        optionsType: 'contractsFieldApi',
        options: [],
        value: '',
        optional: true,
      },
      ...getItemIdFromArgsConfig,
      ...alertMessagesArgsConfig,
    ],
  },
];
